import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */
var MotionValue = /*#__PURE__*/function () {
  function MotionValue() {
    _classCallCheck(this, MotionValue);
  }

  _createClass(MotionValue, [{
    key: "setAnimation",
    value: function setAnimation(animation) {
      var _this = this;

      this.animation = animation;
      animation === null || animation === void 0 ? void 0 : animation.finished.then(function () {
        return _this.clearAnimation();
      }).catch(function () {});
    }
  }, {
    key: "clearAnimation",
    value: function clearAnimation() {
      this.animation = this.generator = undefined;
    }
  }]);

  return MotionValue;
}();

export { MotionValue };